'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Reservation = require('@wix/wixrest-utils/dist/openrest-helpers/Reservation');

var _Reservation2 = _interopRequireDefault(_Reservation);

var _EmailIcons = require('../EmailIcons');

var _ReservationEmailStyle = require('./ReservationEmailStyle.style');

var _ReservationEmailStyle2 = _interopRequireDefault(_ReservationEmailStyle);

var _DefaultElement = require('oy-vey/lib/components/DefaultElement.js');

var _DefaultElement2 = _interopRequireDefault(_DefaultElement);

var _wixrestUtils = require('@wix/wixrest-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = _DefaultElement2.default.Table,
    TBody = _DefaultElement2.default.TBody,
    TR = _DefaultElement2.default.TR,
    TD = _DefaultElement2.default.TD;


function ReservationContactInfo(_ref) {
    var i18n = _ref.i18n,
        reservation = _ref.reservation,
        restaurant = _ref.restaurant,
        fontFamily = _ref.fontFamily,
        nameMaxWidth = _ref.nameMaxWidth;

    var styles = (0, _ReservationEmailStyle2.default)(i18n.getDir() === 'rtl', fontFamily, nameMaxWidth);
    var displayableReservation = _Reservation2.default.getDisplayableReservation(reservation);
    var phone = _wixrestUtils.PhoneUtils.displayPhone(reservation.contact.phone, _lodash2.default.get(restaurant, 'address.countryCode'));
    var _reservation$contact = reservation.contact,
        firstName = _reservation$contact.firstName,
        lastName = _reservation$contact.lastName,
        email = _reservation$contact.email;

    var profilePicture = displayableReservation.user.profilePicture;

    function renderContactMethod(icon, value) {
        return _react2.default.createElement(
            'span',
            { style: styles.contactMethod },
            _react2.default.createElement(
                'span',
                { style: styles.contactMethodIcon },
                icon
            ),
            _react2.default.createElement(
                'span',
                { style: styles.contactMethodValue },
                value
            )
        );
    }

    return _react2.default.createElement(
        Table,
        null,
        _react2.default.createElement(
            TBody,
            null,
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    null,
                    _react2.default.createElement('img', {
                        style: {
                            borderRadius: 50,
                            width: 53,
                            height: 53
                        },
                        src: profilePicture })
                ),
                _react2.default.createElement(
                    TD,
                    { style: (0, _extends3.default)({}, styles.contactDetails, { padding: 0 }) },
                    _react2.default.createElement(
                        'div',
                        { style: (0, _extends3.default)({}, styles.contactName, { padding: 0, paddingLeft: 18, paddingRight: 18, fontSize: 20 }) },
                        firstName + ' ' + lastName
                    )
                )
            ),
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    { colSpan: 2, style: { paddingTop: '12px' } },
                    renderContactMethod(_react2.default.createElement(_EmailIcons.PhoneIcon, null), phone)
                )
            ),
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    { colSpan: 2, style: { paddingTop: '12px' } },
                    renderContactMethod(_react2.default.createElement(_EmailIcons.EmailIcon, null), email)
                )
            )
        )
    );
}

ReservationContactInfo.displayName = 'ReservationContactInfo';

ReservationContactInfo.propTypes = {
    i18n: _propTypes2.default.object,
    restaurant: _propTypes2.default.object,
    reservation: _propTypes2.default.object,
    fontFamily: _propTypes2.default.string,
    nameMaxWidth: _propTypes2.default.number
};

exports.default = ReservationContactInfo;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationContactInfoVertical.js
// module id = 1187
// module chunks = 0